<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc"><span class="epub-b">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc-bot" id="c_Ack"><a href="#/xhtml/ack#ack">Acknowledgements</a></p>
<p class="toc" id="c_pt1"><a href="#/xhtml/part1#pt1"><span class="epub-b">PART ONE:</span> Children Of The Grave</a></p>
<p class="toc" id="c_ch1"><a href="#/xhtml/chapter1#ch1">One: I, Awake</a></p>
<p class="toc" id="c_ch2"><a href="#/xhtml/chapter2#ch2">Two: The Devil’s Interval</a></p>
<p class="toc" id="c_ch3"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Three: Bringers of War</span></p>
<p class="toc" id="c_ch4"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Four: Pope On A Rope</span></p>
<p class="toc" id="c_ch5"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Five: Killing Yourself To Live</span></p>
<p class="toc-bot" id="c_ch6"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Six: Born To Die</span></p>
<p class="toc" id="c_pt2"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample"><span class="epub-b">PART TWO:</span> Unlucky For Some</span></p>
<p class="toc" id="c_ch7"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Seven: Neon Nights</span></p>
<p class="toc" id="c_ch8"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Eight: Train Wreck</span></p>
<p class="toc" id="c_ch9"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Nine: Mob Rule</span></p>
<p class="toc" id="c_ch10"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Ten: Upside Down Crosses</span></p>
<p class="toc" id="c_ch11"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Eleven: Dehumanised</span></p>
<p class="toc" id="c_ch12"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Twelve: Saviour</span></p>
<p class="toc-bot" id="c_ch13"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Thirteen: 13</span></p>
<p class="toc"><span href="#/xhtml/photo1#photo" title="Link target outside of Sample">Photographs</span></p>
<p class="toc" id="c_Not"><span href="#/xhtml/sou#sou" title="Link target outside of Sample">Notes and Sources</span></p>
<p class="toc" id="c_ind"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc" id="c_Als"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also by Mick Wall</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6d009bac